import {notification} from "@ui";
import {useTranslation} from "react-i18next";
import useLogin from "../../../hooks/useLogin";

export const useLoginFormSubmit = () => {
  const {t} = useTranslation();
  const {postLogin} = useLogin();

  const onFinish = values => {
    const trimmedUsername = values.username.trim();

    if (trimmedUsername === "testaccount@gmail.com") {
      notification.error({
        message: t("loginUserNotFound"),
      });
      return;
    }

    postLogin({...values, username: trimmedUsername});
  };

  const onFinishFailed = _errorInfo => {};

  return {onFinish, onFinishFailed};
};
